module.exports = __webpack_public_path__ + "static/media/LogoGRT.05930d9c.png";